import React, { useState, useContext } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Box, Link } from '@mui/material';
import FormInput from "../../SystemDesign/FormInput";
import MuiDialog from "../../SystemDesign/MuiDialog";
import LockResetIcon from '@mui/icons-material/LockReset';
import { SnackBarContext } from '../../Context/SnackBarContextProvider';
import { useRequestPasswordResetMutation } from "../../services/SkillsManagement";

const DialogResetPassword = ({ open, onClose }) => {


  const [requestPasswordReset] = useRequestPasswordResetMutation();
  const { setInfoAlert, setOpenSnackBar } = useContext(SnackBarContext);

  const validationSchema = Yup.object({
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
  });

  const handleSubmit = async (values, actions) => {
    try {
      await requestPasswordReset({ body: { email: values.email } }).unwrap();
      setInfoAlert({
        severity: 'success',
        message: "A password reset email has been sent."
      });
      setOpenSnackBar(true);
      actions.resetForm();
      if (onClose) onClose();
    } catch (error) {
      setInfoAlert({
        severity: 'error',
        message: error.data?.message || 'An error occurred while sending the email'
      });
      setOpenSnackBar(true);
    }
    actions.setSubmitting(false);
  };

  return (
    <MuiDialog
      icon={<LockResetIcon />}
      open={open}
      onClose={onClose}
      title="Password Reset"
      subtitle="Enter your email address to reset your password"
      content={
        <Box sx={{ p: 1 }}>
          <Formik
            initialValues={{ email: '' }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form id="resetPasswordForm">
                <FormInput
                  name="email"
                  label="Email"
                  type="email"
                  placeholder="Enter your email address"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
                {/* Hidden submit button to allow form submission */}
                <button type="submit" style={{ display: 'none' }} />
              </Form>
            )}
          </Formik>
        </Box>
      }
      existAction={true}
      actionTitle="Send"
      actionFunction={() => {
        // Find and click the hidden submit button to properly trigger Formik validation
        const submitButton = document.querySelector('#resetPasswordForm button[type="submit"]');
        if (submitButton) {
          submitButton.click();
        }
      }}
      actionType="button"
      formId="resetPasswordForm"
    />
  );
};

export default DialogResetPassword;